export default {"src":"/_next/static/media/disasterRecoveryEfficient.9138d0fe.svg","height":600,"width":800,"blurWidth":0,"blurHeight":0};